import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import PauseButtonInlineSvg from '../../../assets/svg-icons/PauseButton.inline.svg';
import PlayButtonInlineSvg from '../../../assets/svg-icons/PlayButton.inline.svg';
import {BarButton} from '../BarButton/BarButton';
import styles from './PlayPauseButton.scss';

export function PlayPauseButton(props) {
  const {isPlaying = false, onClick, className: outerClassName} = props;
  const {t} = useTranslation();
  const className = classNames(outerClassName, isPlaying ? styles.pause : styles.play);

  return (
    <BarButton
      className={className}
      onClick={onClick}
      accName={t('mgw.aria.controlBar.playButtonAccName')}
      aria-pressed={isPlaying}
      SvgIcon={isPlaying ? PauseButtonInlineSvg : PlayButtonInlineSvg}
      dataHook="play-pause-button"
      data-state-is-playing={String(isPlaying)}
    />
  );
}

PlayPauseButton.propTypes = {
  t: PropTypes.func,
  isPlaying: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
